"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCompatiblePriceModels = fetchCompatiblePriceModels;
exports.isListPriceModel = isListPriceModel;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _urijs = _interopRequireDefault(require("urijs"));

var restUtils = _interopRequireWildcard(require("../restUtils"));

var productionUrl = 'https://productprice.financialflows.cimpress.io';
var stageUrl = 'https://stg-productprice.financialflows.cimpress.io';
var compatibilityRoute = '/api/v1/priceModelCompatibility';
var listPriceRoute = '/api/v1/listPrice';

function fetchCompatiblePriceModels(_x, _x2, _x3, _x4) {
  return _fetchCompatiblePriceModels.apply(this, arguments);
}

function _fetchCompatiblePriceModels() {
  _fetchCompatiblePriceModels = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(skus, sellerId, sellerType, token) {
    var isProduction,
        requestUrl,
        _ref2,
        body,
        status,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isProduction = _args.length > 4 && _args[4] !== undefined ? _args[4] : true;
            requestUrl = (0, _urijs.default)(isProduction ? productionUrl : stageUrl).path(compatibilityRoute).query({
              sellerId: sellerId,
              sellerType: sellerType
            }).toString();
            _context.next = 4;
            return restUtils.request('POST', requestUrl, skus, token);

          case 4:
            _ref2 = _context.sent;
            body = _ref2.body;
            status = _ref2.status;

            if (!(status !== 200)) {
              _context.next = 9;
              break;
            }

            throw restUtils.buildDefaultError(status);

          case 9:
            return _context.abrupt("return", body);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _fetchCompatiblePriceModels.apply(this, arguments);
}

function isListPriceModel(_x5) {
  return _isListPriceModel.apply(this, arguments);
}

function _isListPriceModel() {
  _isListPriceModel = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(_ref) {
    var skus, seller, token, _ref$isProduction, isProduction, _ref$priceModel, priceModelId, revisionId, requestUrl, _ref3, body, status;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            skus = _ref.skus, seller = _ref.seller, token = _ref.token, _ref$isProduction = _ref.isProduction, isProduction = _ref$isProduction === void 0 ? true : _ref$isProduction, _ref$priceModel = _ref.priceModel, priceModelId = _ref$priceModel.priceModelId, revisionId = _ref$priceModel.revisionId;
            requestUrl = (0, _urijs.default)(isProduction ? productionUrl : stageUrl).path(listPriceRoute).toString();
            _context2.next = 4;
            return restUtils.request('POST', requestUrl, {
              skus: skus,
              seller: seller,
              priceModelId: priceModelId,
              revisionId: revisionId
            }, token);

          case 4:
            _ref3 = _context2.sent;
            body = _ref3.body;
            status = _ref3.status;

            if (!(status !== 200)) {
              _context2.next = 9;
              break;
            }

            throw restUtils.buildDefaultError(status);

          case 9:
            return _context2.abrupt("return", !!body.length);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _isListPriceModel.apply(this, arguments);
}